import { Typography } from "../../molecules/Typography";
import { usePrintComponentStore } from "../../organism/PrintComponent/store/usePrintComponentStore";
import { PaperContainer, ExerciseText } from "./variants";

const AnswerSheet = () => {
   const { data, hasMoreExercises } = usePrintComponentStore();

   return (
      <div id="answerContainer" className='bg-color-lighter h-[30vh] pt-2 overflow-auto rounded-lg'>
         <Typography type='title' size='h5' className='ml-4'>
          Gabarito
         </Typography>
         <div className={PaperContainer({ cols: 'split' })}>
            {data.length > 0 && data.map((it: any, i: number) => (
               <div key={i} className='flex flex-col gap-xs mb-5 pr-5'>
                  <Typography type='title' size='h6'>
                     Exercício {i + 1}
                  </Typography>
                  {it.alternatives &&
                  it.alternatives.map((alternative: any) => {
                     return (
                        alternative &&
                        alternative.correct && (
                        <span
                           key={`feedback-print-${alternative._id}`}
                           className={ExerciseText({ size: hasMoreExercises ? 'small' : 'default'})}
                           dangerouslySetInnerHTML={{ __html: alternative.text }}
                        />
                        )
                     );
                  })}
               </div>
            ))}
         </div>
      </div>
   )
}

  export default AnswerSheet;